import React from 'react';

import { Input } from './ui/input';
import { Button } from './ui/button';
import { Label } from './ui/label';

import NavBar from './NavBar';
import Store from './Store';
import Card from './Card';
import firebaseApp from '../firebaseApp';

export default function LoginWithEmail({ drawerToggle }) {
  let [email, setEmail] = React.useState('');
  let [loading, setLoading] = React.useState(false);

  let login = async e => {
    e.preventDefault();
    setLoading(true);
    localStorage.setItem('signInEmail', email);
    try {
      await firebaseApp.auth().sendSignInLinkToEmail(email, {
        handleCodeInApp: true,
        url: 'https://app.pushback.io/',
        android: {
          installApp: true,
          packageName: 'io.pushback',
        },
        iOS: {
          bundleId: 'io.pushback.PushBack',
        },
      });
      setLoading(false);
      Store.setSuccess('Login link sent. Please check your inbox');
    } catch (e) {
      Store.onFailure(e);
    }
  };

  return (
    <div className="flex flex-col w-full h-full items-center">
      <NavBar />
      <Card className="p-8">
        <form
          className="flex flex-col min-w-[300px] p-4"
          name="login"
          onSubmit={login}
        >
          <h2 className="mt-4 mb-4 text-xl font-semibold">
            Please enter an email to login or sign up
          </h2>
          <div className="flex flex-col space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              autoFocus
              onChange={e => setEmail(e.target.value)}
              autoComplete="email"
              type="email"
              required
              className="w-[240px]"
            />
          </div>
          <Button className="mt-4 self-end" type="submit" disabled={loading}>
            Send
          </Button>
        </form>
      </Card>
    </div>
  );
}
